/* eslint-disable perfectionist/sort-objects */

import shippingUomLabels from "~fulfill/product/helpers/shippingUomLabels";

const customerPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/customers": {
		nav: true,
		title: "",
		description: "",
		label: "Customers",
		labelKey: "nav.fulfill.customers.list.label",
		buttons: [],
		actions: []
	},
	"/fulfill/customers/customer.+": {
		nav: false,
		title: "",
		description: "",
		label: "Customer",
		labelKey: "nav.fulfill.customers.detail.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/customers/routes": {
		nav: true,
		title: "",
		description: "",
		label: "Routes",
		labelKey: "nav.fulfill.customers.routes.label",
		buttons: [],
		actions: []
	},
	"/fulfill/customers/groups": {
		nav: true,
		title: "",
		description: "",
		label: "Groups",
		labelKey: "nav.fulfill.customers.groups.label",
		buttons: [],
		actions: []
	},
	"/fulfill/customers/import": {
		nav: false,
		title: "",
		description: "",
		label: "CSV Import",
		labelKey: "nav.fulfill.customers.import.label",
		buttons: [],
		actions: []
	}
};

const orderPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/orders/order.+": {
		nav: false,
		title: "",
		description: "",
		label: "Order",
		labelKey: "nav.fulfill.orders.detail.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/orders/import": {
		nav: false,
		title: "",
		description: "",
		label: "CSV Import",
		labelKey: "nav.fulfill.orders.import.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/logistics/planning": {
		nav: true,
		title: "Planning",
		titleKey: "nav.fulfill.logistics.planning.title",
		description: "Plan the orders going out — their route, drop and containers",
		descriptionKey: "nav.fulfill.logistics.planning.description",
		label: "Planning",
		labelKey: "nav.fulfill.logistics.planning.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/logistics/planning/orders": {
		nav: false,
		title: "Orders",
		titleKey: "nav.fulfill.logistics.planning.orders.title",
		description: "Check off the orders going out and see what they load onto, per route",
		descriptionKey: "nav.fulfill.logistics.planning.orders.description",
		label: "Orders",
		labelKey: "nav.fulfill.logistics.planning.orders.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/orders/master-order.+": {
		nav: false,
		title: "",
		description: "",
		label: "Master Order",
		labelKey: "nav.fulfill.orders.masterOrder.label",
		buttons: [],
		actions: [],
		identifier: true
	}
};

const productPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/product/items": {
		nav: true,
		title: "",
		description: "",
		label: "Items",
		labelKey: "nav.fulfill.product.items.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/items/import": {
		nav: false,
		title: "",
		description: "",
		label: "CSV Import",
		labelKey: "nav.fulfill.product.itemsImport.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/items/images/import": {
		nav: false,
		title: "",
		description: "",
		label: "Bulk Image Upload",
		labelKey: "nav.fulfill.product.itemsImageImport.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/items/.+/skuUpcMapping/import": {
		nav: false,
		title: "",
		description: "",
		label: "Customer Items CSV Import",
		labelKey: "nav.fulfill.product.customerItemsImport.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/categories": {
		nav: true,
		title: "",
		description: "",
		label: "Categories",
		labelKey: "nav.fulfill.product.categories.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/hard-goods": {
		nav: true,
		title: "Hard Goods",
		titleKey: "nav.fulfill.product.hardGoods.title",
		description: "View hard goods and control whether each is sellable in Fulfill",
		descriptionKey: "nav.fulfill.product.hardGoods.description",
		label: "Hard Goods",
		labelKey: "nav.fulfill.product.hardGoods.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/kits": {
		nav: true,
		title: "Kits",
		titleKey: "nav.fulfill.product.kits.title",
		description: "Build named combinations of items on containers and track capacity consumption",
		descriptionKey: "nav.fulfill.product.kits.description",
		label: "Kits",
		labelKey: "nav.fulfill.product.kits.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/maintenance/containers": {
		nav: true,
		title: "",
		description: "",
		label: "Containers",
		labelKey: "nav.fulfill.product.containers.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/maintenance/categories": {
		nav: true,
		title: "",
		description: "",
		label: shippingUomLabels.entityPlural,
		labelKey: "nav.fulfill.product.shippingConfigCategories.label",
		buttons: [],
		actions: []
	},
	"/fulfill/product/maintenance/size-uoms": {
		nav: false,
		title: "",
		description: "",
		label: shippingUomLabels.entityPlural,
		buttons: [],
		actions: []
	}
};

const inventoryPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/inventory/import": {
		nav: false,
		title: "Import Inventory",
		titleKey: "nav.fulfill.inventory.import.title",
		description: "Import inventory data from a CSV file",
		descriptionKey: "nav.fulfill.inventory.import.description",
		label: "CSV Import",
		labelKey: "nav.fulfill.inventory.import.label",
		buttons: [],
		actions: []
	},
	"/fulfill/inventory/scheduled-transfers": {
		nav: false,
		title: "Scheduled Transfers",
		titleKey: "nav.fulfill.inventory.scheduledTransfers.title",
		description: "Review scheduled item-to-item transfers and what each one did",
		descriptionKey: "nav.fulfill.inventory.scheduledTransfers.description",
		label: "Scheduled Transfers",
		labelKey: "nav.fulfill.inventory.scheduledTransfers.label",
		buttons: [],
		actions: []
	}
};

const purchasingPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/purchasing/vendors": {
		nav: true,
		title: "Vendors",
		titleKey: "nav.fulfill.purchasing.vendors.title",
		description: "View and manage vendor information",
		descriptionKey: "nav.fulfill.purchasing.vendors.description",
		label: "Vendors",
		labelKey: "nav.fulfill.purchasing.vendors.label",
		buttons: [],
		actions: []
	},
	"/fulfill/purchasing/orders": {
		nav: true,
		title: "Purchase Orders",
		titleKey: "nav.fulfill.purchasing.orders.title",
		description: "View, create, and manage purchase orders",
		descriptionKey: "nav.fulfill.purchasing.orders.description",
		label: "Purchase Orders",
		labelKey: "nav.fulfill.purchasing.orders.label",
		buttons: [],
		actions: []
	}
};

const flattenPageMapping = (mapping: { [key: string]: PageMapping }): { [key: string]: PageMapping } => {
	const out: { [key: string]: PageMapping } = {};
	Object.entries(mapping).forEach(([key, value]) => {
		out[key] = value;
		if (value.children) Object.assign(out, flattenPageMapping(value.children));
	});
	return out;
};

const pricePageMapping: { [key: string]: PageMapping } = {
	"/fulfill/sales/pricing/groups": {
		nav: true,
		title: "",
		description: "",
		label: "Groups",
		labelKey: "nav.fulfill.pricing.groups.label",
		buttons: [],
		actions: []
	},
	"/fulfill/sales/pricing/groups/group/.+": {
		nav: false,
		title: "",
		description: "",
		label: "Group",
		labelKey: "nav.fulfill.pricing.group.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/sales/pricing/groups/import": {
		nav: false,
		title: "",
		description: "",
		label: "CSV Import",
		labelKey: "nav.fulfill.pricing.groupsImport.label",
		buttons: [],
		actions: []
	}
};

const salesPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/sales/pricing": {
		nav: true,
		title: "",
		description: "",
		label: "Pricing",
		labelKey: "nav.fulfill.sales.pricing.label",
		buttons: [],
		actions: []
	},
	"/fulfill/sales/pricing/erp": {
		nav: true,
		title: "",
		description: "",
		label: "ERP Pricing",
		labelKey: "nav.fulfill.sales.erpPricing.label",
		buttons: [],
		actions: []
	},
	"/fulfill/sales/terms": {
		nav: true,
		title: "",
		description: "",
		label: "Terms",
		labelKey: "nav.fulfill.sales.terms.label",
		buttons: [],
		actions: []
	},
	"/fulfill/sales/terms/import": {
		nav: false,
		title: "",
		description: "",
		label: "CSV Import",
		labelKey: "nav.fulfill.sales.termsImport.label",
		buttons: [],
		actions: []
	},
	"/fulfill/sales/statements": {
		nav: true,
		title: "",
		description: "",
		label: "Statements",
		labelKey: "nav.fulfill.sales.statements.label",
		buttons: [],
		actions: []
	},
	"/fulfill/sales/invoices": {
		nav: true,
		title: "",
		description: "",
		label: "Invoices",
		labelKey: "nav.fulfill.sales.invoices.label",
		buttons: [],
		actions: []
	},
	"/fulfill/sales/invoices/.+": {
		nav: false,
		title: "",
		description: "",
		label: "Invoice",
		labelKey: "nav.fulfill.sales.invoices.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/sales/receivables": {
		nav: true,
		title: "",
		description: "",
		label: "Receive Payments",
		labelKey: "nav.fulfill.sales.receivables.label",
		buttons: [],
		actions: []
	}
};

const locationPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/locations": {
		nav: true,
		title: "",
		description: "",
		label: "Locations",
		labelKey: "nav.fulfill.locations.list.label",
		buttons: [],
		actions: []
	},
	"/fulfill/locations/location.+": {
		nav: false,
		title: "",
		description: "",
		label: "Location",
		labelKey: "nav.fulfill.locations.detail.label",
		buttons: [],
		actions: [],
		identifier: true
	},
	"/fulfill/locations/import": {
		nav: false,
		title: "",
		description: "",
		label: "CSV Import",
		labelKey: "nav.fulfill.locations.import.label",
		buttons: [],
		actions: []
	}
};

const portalPageMapping: { [key: string]: PageMapping } = {
	"/fulfill/portal/quick-orders": {
		nav: true,
		title: "",
		description: "",
		label: "Quick Orders",
		labelKey: "nav.fulfill.portal.quickOrders.label",
		buttons: [],
		actions: []
	},
	"/fulfill/portal/branding": {
		nav: true,
		title: "",
		description: "",
		label: "Branding",
		labelKey: "nav.fulfill.portal.branding.label",
		buttons: [],
		actions: []
	},
	"/fulfill/portal/settings": {
		nav: true,
		title: "",
		description: "",
		label: "Settings",
		labelKey: "nav.fulfill.portal.settings.label",
		buttons: [],
		actions: []
	}
};

export const featurePageMapping: { [key: string]: PageMapping } = {
	"/fulfill": {
		nav: false,
		title: "",
		label: "Fulfill",
		labelKey: "nav.fulfill.sections.fulfill.label",
		icon: "home",
		buttons: [],
		actions: []
	},
	"/fulfill/customers": {
		nav: false,
		title: "",
		label: "Customers",
		labelKey: "nav.fulfill.sections.customers.label",
		icon: "business",
		buttons: [],
		actions: [],
		children: customerPageMapping
	},
	"/fulfill/locations": {
		nav: true,
		title: "",
		description: "",
		label: "Locations",
		labelKey: "nav.fulfill.sections.locations.label",
		icon: "location_pin",
		buttons: [],
		actions: []
	},
	"/fulfill/sales": {
		nav: false,
		title: "",
		label: "Sales",
		labelKey: "nav.fulfill.sections.sales.label",
		icon: "sell",
		buttons: [],
		actions: [],
		children: salesPageMapping
	},
	"/fulfill/product": {
		nav: false,
		title: "",
		label: "Product",
		labelKey: "nav.fulfill.sections.product.label",
		icon: "widgets",
		buttons: [],
		actions: [],
		children: productPageMapping
	},
	"/fulfill/orders": {
		nav: true,
		title: "",
		label: "Orders",
		labelKey: "nav.fulfill.sections.orders.label",
		icon: "shopping_cart",
		buttons: [],
		actions: []
	},
	"/fulfill/purchasing": {
		nav: false,
		title: "",
		label: "Purchasing",
		labelKey: "nav.fulfill.sections.purchasing.label",
		icon: "local_shipping",
		buttons: [],
		actions: [],
		children: purchasingPageMapping
	},
	"/fulfill/inventory": {
		nav: true,
		title: "",
		description: "",
		label: "Inventory",
		labelKey: "nav.fulfill.sections.inventory.label",
		icon: "inventory_2",
		buttons: [],
		actions: []
	},
	"/fulfill/portal": {
		nav: false,
		title: "",
		label: "Portal",
		labelKey: "nav.fulfill.sections.portal.label",
		icon: "storefront",
		buttons: [],
		actions: [],
		children: portalPageMapping
	}
};
//faltten the page mapping for easy access

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	...orderPageMapping,
	...pricePageMapping,
	...salesPageMapping,
	...flattenPageMapping(productPageMapping),
	...purchasingPageMapping,
	...inventoryPageMapping,
	...customerPageMapping,
	...locationPageMapping,
	...portalPageMapping
};
